import $ from 'jquery';

class MaRSReports {

  //describe and create/initiate object
  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.resultsDiv = $(".allReports__Results");
    this.showButton = $(".allReports__link");
    this.filterSelect = $(".allReports__filter-child li");
    this.searchField = $("#venture-search");
    this.loadMoreButton = $(".allReports__load a");
    this.postsPerPage = 9;
    this.screenWidth = $(window).width();
    this.events();
    this.isSpinnerVisible = false;
    this.isOverlayOpen = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
    this.docIcon = MaRS_DATA.assets_url + '/mars-branding/doc.svg';
    this.xlsIcon = MaRS_DATA.assets_url + '/mars-branding/xls.svg';
    this.pdfIcon = MaRS_DATA.assets_url + '/mars-branding/pdf.svg';

    this.getFileExtension = (filename) => {
      return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
    }
  }

  //events
  events() {
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
    this.searchField.on("keyup", this.typingLogic.bind(this));
    this.filterSelect.on("click", this.filterLogicSector.bind(this));
  }

  //methods (function, action...)
  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer);
      $(".mtoggle li.active span").html($(".mtoggle li.active span").attr("data-hold"));

      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
        this.isSpinnerVisible = true;
      }
    }
    this.previousValue = this.searchField.val();
  }


  filterLogicSector(e) {
    if ($(this)) {
      let curTarget = e.currentTarget;
      let target, slug = e.target;
      target = slug.getAttribute('data-name');
      let attrType = curTarget.parentElement.getAttribute('data-pane');

      if (target) {
        clearTimeout(this.typingTimer);
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, target), 750);
      } else if (!target && !this.isOpened) {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, target), 750);
        this.isSpinnerVisible = true;
      }
    }
  }


  getResults() {
    if ($(".allReports__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/reports?term=' + this.searchField.val() + '&page=1', (results) => {
        let currentPage = results.current_page;

        this.resultsDiv.html(`
            
           ${results.reportInfo.length ? '<div class="row allReports__row">' : '<p>No Report information matches that search.</p>'}
            ${results.reportInfo.map(item => `
               
              <div class="col-sm-12 col-md-4" data-enter="fade" data-enter-delay="50">
                <div class="report__box">
                  <a href="${item.file}" target="_blank">
                    <p class="report__subtitle">${item.report_type_name}</p>
                    <h4>${item.title}</h4>
                    <div class="clear">
                      <i class="reportArrow__icon"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                        <path d="M1 5h42M40 1l4 4-4 4"></path>
                      </g></svg></i>
                      <i class="reportType__icon" style="background: url('${(this.getFileExtension(item.file) === 'xls' || this.getFileExtension(item.file) === 'xlsx' || this.getFileExtension(item.file) === 'pdf') ? ((this.getFileExtension(item.file) === 'xls' || this.getFileExtension(item.file) === 'xlsx' ) ? this.xlsIcon : this.pdfIcon) : this.docIcon}') no-repeat top left;"></i>
                    </div>
                  </a>
                </div>
              </div>

          `).join('')}
          ${results.reportInfo.length ? '</div>' : ''}
       
      `);
        this.isSpinnerVisible = false;
        this.searchField.val() ? this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=2`) : '';
        `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getFilterResults(type, typeValue) {
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/reports?' + type + '=' + typeValue + '&page=1', (results) => {
      let currentPage = results.current_page;

      this.resultsDiv.html(`
         
            ${results.reportInfo.length ? '<div class="row allReports__row">' : '<p>No Report information matches that search.</p>'}
            ${results.reportInfo.map(item => `
               
              <div class="col-sm-12 col-md-4" data-enter="fade" data-enter-delay="50">
                <div class="report__box">
                  <a href="${item.file}" target="_blank">
                    <p class="report__subtitle">${item.report_type_name}</p>
                    <h4>${item.title}</h4>
                    <div class="clear">
                      <i class="reportArrow__icon"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                        <path d="M1 5h42M40 1l4 4-4 4"></path>
                      </g></svg></i>
                      <i class="reportType__icon" style="background: url('${(this.getFileExtension(item.file) === 'xls' || this.getFileExtension(item.file) === 'xlsx' || this.getFileExtension(item.file) === 'pdf') ? ((this.getFileExtension(item.file) === 'xls' || this.getFileExtension(item.file) === 'xlsx' ) ? this.xlsIcon : this.pdfIcon) : this.docIcon}') no-repeat top left;"></i>
                    </div>
                  </a>
                </div>
              </div>

          `).join('')}
          ${results.reportInfo.length ? '</div>' : ''}
     
      `);
      this.isSpinnerVisible = false;
      //`${results.reportInfo.length == this.postsPerPage ? this.loadMoreButton.show() : this.loadMoreButton.hide()}`;
      typeValue ? this.loadMoreButton.attr("data-url", `type=${typeValue}&page=2`) : this.loadMoreButton.attr("data-url", `term=${typeValue}&page=2`);
      `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

  LoadActiveResults() {

    if ($(".allReports__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/reports?term=&page=1', (results) => {
        let currentPage = results.current_page;

        this.resultsDiv.html(`

          ${results.reportInfo.length ? '<div class="row allReports__row">' : '<p>No Report information matches that search.</p>'}
            ${results.reportInfo.map(item => `
               
              <div class="col-sm-12 col-md-4" data-enter="fade" data-enter-delay="50">
                <div class="report__box">
                  <a href="${item.file}" target="_blank">
                    <p class="report__subtitle">${item.report_type_name}</p>
                    <h4>${item.title}</h4>
                    <div class="clear">
                      <i class="reportArrow__icon"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                        <path d="M1 5h42M40 1l4 4-4 4"></path>
                      </g></svg></i>
                      <i class="reportType__icon" style="background: url('${(this.getFileExtension(item.file) === 'xls' || this.getFileExtension(item.file) === 'xlsx' || this.getFileExtension(item.file) === 'pdf') ? ((this.getFileExtension(item.file) === 'xls' || this.getFileExtension(item.file) === 'xlsx' ) ? this.xlsIcon : this.pdfIcon) : this.docIcon}') no-repeat top left;"></i>
                    </div>
                  </a>
                </div>
              </div>

          `).join('')}
          ${results.reportInfo.length ? '</div>' : ''}

      `);
        this.isSpinnerVisible = false;

        //`${results.reportInfo.length == this.postsPerPage ? this.loadMoreButton.show() : this.loadMoreButton.hide()}`;
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
        `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");

    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/reports?' + this.loadInfo, (results) => {
      let currentPage = results.current_page;
      this.resultsDiv.append(`
   
        ${results.reportInfo.length ? '<div class="row allReports__row">' : '<p>No Report information matches that search.</p>'}
            ${results.reportInfo.map(item => `
               
              <div class="col-sm-12 col-md-4" data-enter="fade" data-enter-delay="50">
                <div class="report__box">
                  <a href="${item.file}" target="_blank">
                    <p class="report__subtitle">${item.report_type_name}</p>
                    <h4>${item.title}</h4>
                    <div class="clear">
                      <i class="reportArrow__icon"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                        <path d="M1 5h42M40 1l4 4-4 4"></path>
                      </g></svg></i>
                      <i class="reportType__icon" style="background: url('${(this.getFileExtension(item.file) === 'xls' || this.getFileExtension(item.file) === 'xlsx' || this.getFileExtension(item.file) === 'pdf') ? ((this.getFileExtension(item.file) === 'xls' || this.getFileExtension(item.file) === 'xlsx' ) ? this.xlsIcon : this.pdfIcon) : this.docIcon}') no-repeat top left;"></i>
                    </div>
                  </a>
                </div>
              </div>

          `).join('')}
          ${results.reportInfo.length ? '</div>' : ''}
      `);

      setTimeout(function() {
        let elmnt = document.querySelectorAll(".allReports__Results .allReports__row");
        elmnt = elmnt[elmnt.length - 1];
        let offset = $(elmnt).offset();
        $('html, body').animate({
          scrollTop: offset.top - 70,
          scrollLeft: offset.left
        });
      }, 500);

      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;

      this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
      `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

}

export default MaRSReports;
